export { SkeletonText } from './SkeletonText';
